import React, { useEffect } from 'react';
import { CookieConsentService, ConsentCategories } from '@/services/CookieConsentService';
import { initializeAnalytics, disableAnalytics } from '@/lib/analytics';
import { logger } from '@/utils/logger';

const CookieEnforcementManager: React.FC = () => {
  useEffect(() => {
    // Initial check
    const consent = CookieConsentService.getConsent();
    if (consent) {
      enforceConsent(consent);
    }

    // Listen for updates
    const handleUpdate = (event: Event) => {
      const customEvent = event as CustomEvent<ConsentCategories>;
      enforceConsent(customEvent.detail);
    };

    window.addEventListener('cookie-consent-updated', handleUpdate);

    return () => {
      window.removeEventListener('cookie-consent-updated', handleUpdate);
    };
  }, []);

  const enforceConsent = (consent: ConsentCategories) => {
    if (consent.analytics) {
      initializeAnalytics(true);
    } else {
      disableAnalytics();
    }

    if (consent.marketing) {
      enableMarketing();
    } else {
      disableMarketing();
    }
  };

  const enableMarketing = () => {
    if (document.getElementById('facebook-pixel-script')) return;
    logger.info('Enabling marketing...');
    // Load Pixel or other marketing scripts
  };

  const disableMarketing = () => {
    logger.info('Disabling marketing...');
    const script = document.getElementById('facebook-pixel-script');
    if (script) script.remove();

    document.cookie.split(';').forEach(c => {
      if (c.trim().startsWith('_fbp')) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
      }
    });
  };

  return null; // No UI
};

export default CookieEnforcementManager;